var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNutrition = function SvgIconNutrition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M10 23H2V1h18v4M7 7h6m-6 5h3m-3 5h1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m18 22.567 1.084.338a2 2 0 0 0 2.487-1.163l1.247-3.5c.875-2.456-1.549-4.824-4.209-4.113l-.609.162-.609-.163c-2.66-.711-5.084 1.657-4.209 4.113l1.247 3.5a2 2 0 0 0 2.487 1.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M21 8v1a3 3 0 0 1-3 3v-1a3 3 0 0 1 3-3"
  }))));
};
export { SvgIconNutrition as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBkPSJNMTAgMjNIMlYxaDE4djRNNyA3aDZNNyAxMmgzTTcgMTdoMSIvPgogICAgICAgIDxwYXRoIGQ9Im0xOCAyMi41NjcgMS4wODQuMzM4YTIgMiAwIDAgMCAyLjQ4Ny0xLjE2M2wxLjI0Ny0zLjVjLjg3NS0yLjQ1Ni0xLjU0OS00LjgyNC00LjIwOS00LjExM2wtLjYwOS4xNjItLjYwOS0uMTYzYy0yLjY2LS43MTEtNS4wODQgMS42NTctNC4yMDkgNC4xMTNsMS4yNDcgMy41YTIgMiAwIDAgMCAyLjQ4NyAxLjE1OUwxOCAyMi41Njd6IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMSA4djFhMyAzIDAgMCAxLTMgM3YtMWEzIDMgMCAwIDEgMy0zeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";